import {
  enterPhoneImmersiveMode,
  usePhoneImmersiveStart,
  usePortraitOnPhone,
  usePhoneViewportFlag,
} from '../hooks/use-phone-gameplay-immersive';
import styles from './phone-gameplay-immersive.module.css';

export function PhoneGameplayImmersiveOverlays(): JSX.Element | null {
  const isPhone = usePhoneViewportFlag();
  const portrait = usePortraitOnPhone();
  const { showStartOverlay, onStartTap } = usePhoneImmersiveStart();

  if (!isPhone) return null;

  if (portrait) {
    return (
      <div className={styles.overlay} role="dialog" aria-modal="true" aria-live="polite">
        <div className={styles.rotateIcon} aria-hidden>
          📱
        </div>
        <h2>Merci de vous mettre en mode paysage</h2>
        <p>
          Cette expérience est prévue en largeur. Tournez votre téléphone ou désactivez le verrouillage
          de rotation.
        </p>
        <button
          type="button"
          className={styles.cta}
          onClick={() => void enterPhoneImmersiveMode()}
        >
          Réessayer le mode paysage
        </button>
      </div>
    );
  }

  if (showStartOverlay) {
    return (
      <div className={styles.overlay} role="dialog" aria-modal="true" aria-live="polite">
        <h2>Mode jeu sur mobile</h2>
        <p>
          Appuyez pour activer le plein écran et le paysage si votre navigateur le permet.
        </p>
        <button type="button" className={styles.cta} onClick={onStartTap}>
          Continuer
        </button>
      </div>
    );
  }

  return null
}
